<template>
  <i18n-t
    tag="p"
    keypath="paymentLegal"
    class="text-sm font-light"
  >
    <template #privacy>
      <NuxtLink
        :to="$t('Privacy URL')"
        :alt="$t('Privacy Policy')"
        target="_blank"
        class="underline"
      >
        {{ $t('Privacy Policy') }}
      </NuxtLink>
    </template>

    <template #conditions>
      <NuxtLink
        :to="$t('AGB URL')"
        :alt="$t('Terms and conditions - short')"
        target="_blank"
        class="underline"
      >
        {{ $t('Terms and conditions - short') }}
      </NuxtLink>
    </template>

    <template #withdrawal>
      <NuxtLink
        :to="$t('Right of withdrawal URL')"
        :alt="$t('Right of withdrawal')"
        target="_blank"
        class="underline"
      >
        {{ $t('Right of withdrawal') }}
      </NuxtLink>
    </template>
  </i18n-t>
</template>
